module.exports = __webpack_public_path__ + "static/img/user.2543d08f.png";